<template>
  <div>
    <template v-if="dataLoaded">
      <div class="popup-content">
        <h3 class="title" :class="classFromColorIndex(colorIndex, 'text-primary','text-secondary')">
          {{ pointDetails.title }}
        </h3>
        <div class="details">
          <component :is="detailsComponent" :point-details="pointDetails" />
        </div>
        <ActionButton :action-url="actionUrlWithParams" :color-index="colorIndex">
          <template #action-button-text>
            {{ actionButtonText }}
          </template>
        </ActionButton>
      </div>
    </template>
    <div v-else class="loading-placeholder">
      <LoadingSpinner />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/loading-spinner'
import ActionButton from '@/components/buttons/action-button'
import { actionUrlWithParamsMixin } from '../action-url-with-params'
import EventDetails from './event-details'
import LocalChapterDetails from './local-chapter-details'
import { mapState } from 'vuex'
import { urlWithParams } from '@/helpers/url-params'

export default {
  components: { EventDetails, LoadingSpinner, LocalChapterDetails, ActionButton },

  mixins: [ actionUrlWithParamsMixin ],

  props: {
    dataLoaded: {
      type: Boolean,
      required: true
    },
    pointDetails: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(['additionalParamsIncludedInEventUrls']),

    actionButtonText() {
      return this.i18n.t(this.pointType === 'group' ? 'local_chapters.show.join' : 'public.events.rsvp')
    },
    actionUrl() {
      switch (this.pointDetails.type) {
      case 'ExternalEvent':
        return this.pointDetails.url
      case 'Event':
        return urlWithParams(this.pointDetails.publicPath, this.additionalParamsIncludedInEventUrls)
      default:
        return this.pointDetails.publicPath
      }
    },
    colorIndex() {
      return this.colorIndexForType(this.pointType)
    },
    detailsComponent() {
      if (this.pointType === 'group') {
        return 'LocalChapterDetails'
      } else {
        return 'EventDetails'
      }
    },
    pointType() {
      return this.pointDetails.type === 'Group' ? 'group' : 'event'
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 5px 5px 0 5px;
  display: flex;
  flex-direction: column;
}

.title {
  margin-top: 0;
  margin-bottom: 0;
  overflow-wrap: break-word;
}

.details {
  padding-top: 6px;
}

.loading-placeholder {
  width: 225px;
  height: 150px;
}
</style>
